'use es6';

import getIn from 'transmute/getIn';
export const getPendingImagesId = getIn(['fileIdsByStatus', 'PENDING_WHEN_MESSAGE_PUBLISHED']);